import { For } from "solid-js";

import { Card, CardContent, Skeleton } from "@fleet/ui";

const DEFAULT_CARD_ROWS = 4;
const DEFAULT_BAR_ROWS = 5;

/**
 * Granular skeletons for data-bound regions of gym screens.
 *
 * Shown ONLY while the query is loading (PowerSync DB not yet
 * ready or initial fetch without data). Replicates the shape of real content so
 * the shell renders instantly without a "flash" of empty state.
 */

/** Card list (routines, exercises, history, measurements). */
export function CardListSkeleton(props: { rows?: number; compact?: boolean }) {
  const rows = () => props.rows ?? DEFAULT_CARD_ROWS;
  return (
    <div class="grid gap-2" aria-hidden="true">
      <For each={Array.from({ length: rows() })}>
        {() => (
          <Card>
            <CardContent
              class={`flex items-center justify-between gap-3 ${props.compact ? "px-4 py-3" : "p-4"}`}
            >
              <div class="min-w-0 flex-1 space-y-2">
                <Skeleton class="h-4 w-2/5" />
                <Skeleton class="h-3 w-3/5" />
              </div>
              <Skeleton class="h-8 w-16 shrink-0 rounded-md" />
            </CardContent>
          </Card>
        )}
      </For>
    </div>
  );
}

/** Horizontal bars (weekly summary by muscle group). */
export function BarListSkeleton(props: { rows?: number }) {
  const rows = () => props.rows ?? DEFAULT_BAR_ROWS;
  return (
    <div class="grid gap-2" aria-hidden="true">
      <For each={Array.from({ length: rows() })}>
        {() => (
          <Card>
            <CardContent class="p-3.5 space-y-2">
              <div class="flex items-center justify-between gap-2">
                <Skeleton class="h-3.5 w-20" />
                <Skeleton class="h-3.5 w-24" />
              </div>
              <Skeleton class="h-2 w-full rounded-full" />
            </CardContent>
          </Card>
        )}
      </For>
    </div>
  );
}
